const KEY="pref"

export default class UserPref {
    private _pref:Record<string,any>
    static _i:UserPref
    static get i(){
        if (!this._i) this._i = new UserPref()
        return this._i
    }
    constructor(){
        try {
            const pref = JSON.parse(localStorage.getItem(this.key) || "{}")
            if (pref && pref instanceof Object) this._pref = pref
            else this._pref = {}
        }catch(e){
            this._pref = {}
        }
    }

    get key(){return KEY}
    get(key:string, defaultValue:any=null){return this._pref[key] ?? defaultValue}
    set(key:string, value:any){
        if (value===undefined) delete this._pref[key];
        else this._pref[key] = value
        localStorage.setItem(this.key, JSON.stringify(this._pref))
        return value
    }
}